import { Modal } from 'react-bootstrap';
import './style.scss';

export interface DeliveryProgressModalProps {
  title: string;
  message: string | JSX.Element;
  size?: 'sm' | 'lg' | 'xl';
  isProcessing?: boolean;
}

function DeliveryProgressModal({ 
  title, 
  message, 
  size = 'sm',
  isProcessing = true 
}: DeliveryProgressModalProps) {

  return (
    <Modal 
      size={size} 
      className="delivery-progress-modal" 
      show 
      backdrop="static" 
      centered 
      keyboard={false}
    >
      <Modal.Header className="bg-primary justify-content-center border-0">
        <Modal.Title className="fs-6 text-white">{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center py-4">
        {isProcessing && (
          <div className="delivery-progress-modal__spinner-container mb-3">
            <div className="delivery-progress-modal__spinner">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="delivery-progress-modal__pulse"></div>
            </div>
          </div>
        )}
        
        <div className="delivery-progress-modal__message">
          {typeof message === 'string' ? (
            <div dangerouslySetInnerHTML={{ __html: message || '' }} />
          ) : (
            message || ''
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default DeliveryProgressModal;
